<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 180px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>

                    <el-select size="mini" v-model="formDatas.aawasStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="创建" :value="1"></el-option>
                        <el-option label="生效" :value="2"></el-option>
                        <el-option label="取消" :value="3"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aawasBalanceStatus" clearable @change="partserch"
                        placeholder="请选择扣款状态" style="width: 130px">
                        <el-option label="未扣款" :value="1"></el-option>
                        <el-option label="已扣款" :value="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aawasCustomerStatus" clearable @change="partserch"
                        placeholder="请选择用户确认状态" style="width: 130px">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="确认" :value="2"></el-option>
                        <el-option label="拒绝" :value="3"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
                    <el-button type="warning" size="mini" style="" @click="Out()">导出</el-button>
          
            <el-button type="success" size="mini" style=" " @click="BoxOpen">新增系统对公提现记录</el-button>
          </div>
        </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aawasId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑系统对公提现记录' : '新增系统对公提现记录'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户名称" prop="asId">
                                <el-select v-model="form.asId" filterable clearable placeholder="请选择"
                                    @change="changeType" style="width: 80%;">
                                    <el-option v-for="(item, index) in getAjefShopList_data" :key="index"
                                        :label="item.asName" :value="item.asId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="对公打款截图一" prop="imageOne">
                                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="对公打款截图二" prop="imageTwo">
                                <my-uploadOnly ref="upload" @fileChange="fileChangeTwo" :filearr="fileList2" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter2"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="金额" prop="aawasMoney">
                                <el-input v-model="form.aawasMoney" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="情况说明" prop="aawasDes">
                                <el-input v-model="form.aawasDes" type="textarea" clrearable style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="打款时间" prop="handlerTime">
                                <el-date-picker v-model="form.handlerTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="对公每刻单号" prop="handleMeikeNo">
                                <el-input v-model="form.handleMeikeNo" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>

                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 批量导入 -->
            <el-dialog title="批量导入(只显示处理失败的信息)" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/invoiceEntry.xlsx', '发票入账标记模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefShopReceiptTypeList, updateAjefApplyWithdrawAdvanceSysCancel, updateAjefApplyWithdrawAdvanceSysSend, uploadAjefShopReceiptInBill, getAjefShopListQuick, getAjefApplyWithdrawAdvanceSysList, addAjefApplyWithdrawAdvanceSys, updateAjefShop, updateAjefShopReceiptStatusSend } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            tableLoading: false,
            fileList: [],
            fileList2: [],
            getAjefShopReceiptTypeList_data: [],
            getAjefShopReceiptTypeList_data2: [],
            columnsImport: [{
                field: "",
                key: "a",
                title: "序号",
                width: 50,
                align: "center",
                fixed: 'left',
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return ++rowIndex;
                },
            },
            {
                field: "des",
                key: "des",
                title: "状态",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "invoiceCode",
                key: "invoiceCode",
                title: "发票代码",
                width: 150,
                align: "center",
            },
            {
                field: "invoiceNum",
                key: "invoiceNum",
                title: "发票号码",
                align: "center",
            },
            {
                field: "invoiceDate",
                key: "invoiceDate",
                title: "发票日期",
                align: "center",
            },
            {
                field: "invoiceTypeOrg",
                key: "invoiceTypeOrg",
                title: "发票名称",
                align: "center",
            },],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'aawasId',
            dialog: false,
            edit: false,
            form: {
                asId: '',
                aawasMoney: '',
                imageOne: [],
                imageTwo: [],
                aawasDes: '',
                handlerTime: '',
                handleMeikeNo: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    fixed: 'left',
                    width: 190,

                },
                {
                    field: "aawasMoneyYuan",
                    key: "aawasMoneyYuan",
                    title: "金额",
                    align: "center",
                    width: 170,

                },
                {
                    field: "imageOne",
                    key: "imageOne",
                    title: "打款截图一",
                    align: "center",
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        //查看详情
                                        row.imageOne ? <el-button type="text" size="mini" style="margin-left: 10px;"
                                            onClick={() => this.$emit('child-call', row.imageOne.split(','))}>查看详情</el-button> : ''
                                    }

                                </div>
                            </span>
                        )
                    }

                },

                {
                    field: "imageTwo",
                    key: "imageTwo",
                    title: "打款截图二",
                    align: "center",
                    width: 170,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        //查看详情
                                        row.imageTwo ? <el-button type="text" size="mini" style="margin-left: 10px;"
                                            onClick={() => this.$emit('child-call', row.imageTwo.split(','))}>查看详情</el-button> : ''
                                    }

                                </div>
                            </span>
                        )
                    }

                },
                {
                    field: "aawasDes",
                    key: "aawasDes",
                    title: "情况说明",
                    align: "center",
                    width: 200,

                },
                {
                    field: "handlerTime",
                    key: "handlerTime",
                    title: "打款时间",
                    align: "center",
                    width: 160,

                },
                {
                    field: "handleMeikeNo",
                    key: "handleMeikeNo",
                    title: "对公每刻单号",
                    align: "center",
                    width: 180,

                },


                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "checkusername",
                    key: "checkusername",
                    title: "审核人",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "aawasStatusDes",
                    key: "aawasStatusDes",
                    title: "审核信息",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aawasCustomerStatusDes",
                    key: "aawasCustomerStatusDes",
                    title: "用户情况说明",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aawasStatus",
                    key: "aawasStatus",
                    title: "状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawasStatus == 1 ? <el-tag size="mini" type="danger">创建</el-tag> :
                                        row.aawasStatus == 2 ? <el-tag size="mini" type="success">生效</el-tag> :
                                            row.aawasStatus == 3 ? <el-tag size="mini" type="info">取消</el-tag> :
                                                ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "aawasBalanceStatus",
                    key: "aawasBalanceStatus",
                    title: "扣款状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawasBalanceStatus == 1 ? <el-tag size="mini" type="danger">未扣款</el-tag> :
                                        row.aawasBalanceStatus == 2 ? <el-tag size="mini" type="success">已扣款</el-tag> :
                                            ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "aawasCustomerStatus",
                    key: "aawasCustomerStatus",
                    title: "用户确认状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawasCustomerStatus == 1 ? <el-tag size="mini" >待确认</el-tag> :
                                        row.aawasCustomerStatus == 2 ? <el-tag size="mini" type="success">确认</el-tag> :
                                            row.aawasCustomerStatus == 3 ? <el-tag size="success" size="mini" type="danger">拒绝</el-tag> :
                                                ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "aawasStatuss",
                    key: "aawasStatuss",
                    title: "审核",
                    align: "center",
                    fixed: 'right',
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawasStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.handleCheck(row)} > 通过 </el-button> : <span></span>
                                }
                                {
                                    row.aawasStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:red" on-click={() => this.handleRefuseCheck(row)} > 取消 </el-button> : <span></span>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })

        this.getList();
    },
    mounted() { },
    methods: {
        removeAfter(file) {
            const url = this.form.imageOne.findIndex(item => item === file)
            this.form.imageOne.splice(url, 1)
        },
        removeAfter2(file) {
            const url = this.form.imageTwo.findIndex(item => item === file)
            this.form.imageTwo.splice(url, 1)
        },
        fileChange(file) {
            if (this.form.imageOne.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.imageOne.indexOf(item) == -1) {
                        this.form.imageOne.push(item);
                        const s = {
                            url: item,
                            name: item
                        }
                        this.fileList.push(s)
                    }
                })
            } else {
                this.$set(this.form, 'imageOne', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        fileChangeTwo(file) {
            if (this.form.imageTwo.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.imageTwo.indexOf(item) == -1) {
                        this.form.imageTwo.push(item)
                        const s = {
                            url: item,
                            name: item
                        }
                        this.fileList2.push(s)
                    }
                })
            } else {
                this.$set(this.form, 'imageTwo', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList2.push(s)
                })

            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        changeType(e) {
            const map = new Map(this.getAjefShopList_data.map(item => [item.asId, item]));
            const item = map.get(e);
            console.log(item);
            this.form.asrtType = item.asrtType
            this.form.realtionIdOld = item.asrtId
            getAjefShopReceiptTypeList({ pageSize: 0, asrtType: item.asrtType }).then(res => {
                this.getAjefShopReceiptTypeList_data = res.data;
            });
        },

        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-apply-withdraw-advance-sys/exportAjefApplyWithdrawAdvanceSys',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '平台对公提现确认记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        getAjefShopListChange(val) {
            console.log(val);
            this.getAjefShopList_data.forEach((item, index) => {
                if (item.asId == val) {
                    this.form.asrDes = item.asrtReceiptTypeName
                }
            })

        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        handleCheck(row) {
            this.$prompt("请输入备注?", "确定要通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefApplyWithdrawAdvanceSysSend({ aawasId: row.aawasId, aawasStatusDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入备注?", "确定要取消吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefApplyWithdrawAdvanceSysCancel({ aawasId: row.aawasId, aawasStatusDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefShopReceiptInBill(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data;
                this.bulkDataCopy = res.data
            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ aawasId: this.theRow.aawasId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopReceiptStatusSend({ aawasIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceiptStatusSend({ aawasIds: row.aawasId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.imageOne = this.form.imageOne.toString()
                        newForm.imageTwo = this.form.imageTwo.toString()
                        addAjefApplyWithdrawAdvanceSys(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.fileList = []
            this.fileList2 = []
            this.form = {
                asId: '',
                aawasMoney: '',
                imageOne: [],
                imageTwo: [],
                aawasDes: '',
                handlerTime: '',
                handleMeikeNo: '',
            };
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aawasId = row.aawasId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefApplyWithdrawAdvanceSysList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefApplyWithdrawAdvanceSysList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefApplyWithdrawAdvanceSysList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>